export const InlineError = ({ text }) => {
  return <div className="text-red-300 font-bold w-full mt-2 text-xs">
      <p>
          {text}
      </p>
  </div>;
};
